import * as React from 'react';
import * as Onboarding from './components';
import { PlainMarkdown } from '@naan/primitives/text';

import __ from 'core/lib/localization';

export const AddToVocabTip = () => {
  return (
    <Onboarding.Container>
      <Onboarding.Content>
        <PlainMarkdown
          source={__(
            'Tap here to save to your vocabulary list.',
            'addToVocabTipBody'
          )}
        />
      </Onboarding.Content>
    </Onboarding.Container>
  );
};
